import React from "react";
import ReactDOM from "react-dom/client";
import CfcTournament from "./CfcTournament.jsx";
import CfcNoResult from "./CfcNoResult";
import { STATUS } from "../../enums.js";

/** @typedef {import('../../transformers/CfcTournamentTransformer.js').CfcTournamentObjForApi } CfcTournamentObjForApi */

/**
 * @typedef {object} CfcTournamentProps
 * @property {?string} limit - Limite du nombre de compétitions à récupérer
 * @property {?(typeof STATUS)[keyof typeof STATUS]} status - Status des compétitions à récupérer (register, coming_soon, live, closed)
 * @property {?('functional_fitness'|'hybrid_race'|'trail')} sportType - Type de sport des compétitions à récupérer
 * @property {Array<CfcTournamentObjForApi>} cfcTournaments - Liste des compétitions
 * @property {boolean} fetchDone - Indique si la récupération des compétitions est terminée
 */

class CfcTournamentItems extends React.Component {
  /**
   * @param {CfcTournamentProps} props
   */
  constructor(props) {
    super(props);
    this.state = {
      limit: props.limit || null,
      status: props.status || null,
      sportType: props.sportType || null,
      cfcTournaments: /** @type {Array<CfcTournamentObjForApi>} */ ([]),
      fetchDone: false
    };
  }

  async componentDidMount() {
    var cfcTournaments = await this.fetchCfcTournaments();

    this.setState({ cfcTournaments, fetchDone: true });
  }

  /**
   * Permet de récupérer la liste des compétitions
   * @returns {Promise<Array<CfcTournamentObjForApi>>} - Liste des compétitions
   */
  async fetchCfcTournaments() {
    const limit = this.state.limit;
    const status = this.state.status;
    const sportType = this.state.sportType;
    let apiUrl = `/api/cfc-tournament/search`;
    const query = new URLSearchParams();

    if (limit) {
      query.set("limit", String(limit));
    }

    if (status) {
      query.set("status", status);
    }

    if (sportType) {
      query.set("sporttype", sportType);
    }

    const queryString = query.toString();

    if (queryString) {
      apiUrl += `?${queryString}`;
    }

    var response = await fetch(apiUrl, {
      headers: {
        Authorization: "gestiaweb"
      }
    });

    return await response.json();
  }

  render() {
    return !this.state.fetchDone ? null : this.state.cfcTournaments.length > 0 ? (
      <div className="grid no-mobile grid--has-4-child grid--product-mobile">
        {this.state.cfcTournaments.map((cfcTournament, index) => (
          <CfcTournament key={`${cfcTournament.registrationLink}-${index}`} cfcTournament={cfcTournament} mode="full" />
        ))}
      </div>
    ) : (
      <CfcNoResult title="Aucune compétition trouvée" message="La prochaine démarre bientôt. En attendant, explorez le calendrier ou revoyez les derniers résultats." />
    );
  }
}

var cfcTournamentsNodes = document.getElementsByClassName("cfc-tournaments");
Array.from(cfcTournamentsNodes).forEach(cfcTournamentsNode => {
  var root = ReactDOM.createRoot(cfcTournamentsNode);
  root.render(<CfcTournamentItems limit={cfcTournamentsNode.getAttribute("data-limit")} status={cfcTournamentsNode.getAttribute("data-status")} sportType={cfcTournamentsNode.getAttribute("data-sporttype")} />);
});
